import { AssignmentStatus } from '@rematter/frontend-lib-api-client';

import { useLoadBoardServicesQuery } from '../queries/useLoadBoardServicesQuery';

import { createMutationHook } from '~/shared/providers/api';

export const useRouteAssignMutation = createMutationHook(
  'transportation.routeAssign',
  (params: {
    id: string;
    assignmentStatus: AssignmentStatus;
    driverId?: string;
    haulerId?: string;
    truckId?: string;
    trailerId?: string;
    estimatedArrival?: string;
  }) => ({
    transportationRouteAssign: {
      __args: {
        id: params.id,
        assignmentStatus: params.assignmentStatus,
        driverId: params.driverId,
        haulerId: params.haulerId,
        truckId: params.truckId,
        trailerId: params.trailerId,
        estimatedArrival: params.estimatedArrival,
      },
      id: true,
      assignmentStatus: true,
      driverId: true,
      haulerId: true,
    },
  }),
  {
    invalidateQueries: [useLoadBoardServicesQuery],
  },
);
